import { IGetOneResponse } from '../util/Types/Generic';
import { UploadImage } from '../util/Types/UploadImage';
import { ApiService } from './ApiService';

interface ExtractTextFile {
  socketId: string,
  nodeId?: string,
  flowId?: string,
  formData: FormData,
}

export class UploadService extends ApiService {
  static pathName = '/upload';

  static uploadFile(
    file: any,
    flowId?: string,
  ): Promise<IGetOneResponse<UploadImage>> {
    return this.post(`${this.pathName}/single`, file);
  }
  
  static extractText = (
    {socketId, nodeId, flowId, formData}: ExtractTextFile
  ): Promise<IGetOneResponse<any>> => {
    if (!nodeId && !flowId) {
      return ApiService.post(
        `${this.pathName}/extract-text-file?socketId=${socketId}`,
        formData,
      );
    }

    return ApiService.post(
      `${this.pathName}/extract-text-file?socketId=${socketId}&nodeId=${nodeId}&flowId=${flowId}`,
      formData,
    );
  };

  static extractTextByLink(data: { url: string, flowId?: string }): Promise<IGetOneResponse<UploadImage>> {
    return this.post(`${this.pathName}/extract-text-link`, data);
  }

  static extractTextFromFiles = (
    socketId: string,
    nodeId: string,
    flowId: string,
    formData: FormData,
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(
      `${this.pathName}/extract-text-files?socketId=${socketId}&nodeId=${nodeId}&flowId=${flowId}`,
      formData,
    );
  };
}
